var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lang"}},[_c('p',{staticStyle:{"display":"none"}},[_c('a',{staticClass:" typo-l6",staticStyle:{"color":"white"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.setLang('vi')}}},[_vm._v("\n      "+_vm._s(_vm.$t('vietnamese'))+"\n    ")]),_vm._v(" "),_c('a',{staticClass:" typo-l6",staticStyle:{"color":"white"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.setLang('en')}}},[_vm._v("\n      "+_vm._s(_vm.$t('english'))+"\n    ")])]),_vm._v(" "),_c('p',[_c('b-form-select',{attrs:{"id":"basicSelect","value":_vm.current_lang,"size":"sm","plain":true,"options":[
                     {
                       text: _vm.$t('vietnamese'),
                       value: 'vi'
                     },
                     {
                       text: _vm.$t('english'),
                       value: 'en'
                     }
                   ]},model:{value:(_vm.current_lang),callback:function ($$v) {_vm.current_lang=$$v},expression:"current_lang"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d548a49","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/ChangeLangues.vue
// module id = 583
// module chunks = 1